export default __webpack_public_path__ + "static/media/role_close.bf266753.svg";